<template>
  <div class="column content-box">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-top"
      icon="add-circle"
      @click="openAddPopup()"
    >
      {{ $t('EVENTS.HEADER_BTN_TXT') }}
    </woot-button>
    <div class="row">
      <div class="small-8 columns with-right-space">
        <div
          v-if="!uiFlags.isFetching && !records.length"
          class="events__empty-state"
        >
          <p class="no-items-error-message">
            {{ $t('EVENTS.LIST.404') }}
          </p>
        </div>
        <woot-loading-state
          v-if="uiFlags.isFetching"
          :message="$t('EVENTS.LOADING')"
        />
        <table
          v-if="!uiFlags.isFetching && records.length"
          aria-describedby="table"
          class="woot-table"
        >
          <thead>
            <th
              v-for="thHeader in $t('EVENTS.LIST.TABLE_HEADER')"
              :key="thHeader"
            >
              {{ thHeader }}
            </th>
          </thead>
          <tbody>
            <event-table-row
              v-for="(event, index) in records"
              :key="event.id"
              :index="index"
              :event="event"
              @edit="openEditPopup"
              @delete="openDeletePopup"
              @toggle-active="toggleEventActive"
            />
          </tbody>
        </table>
      </div>
      <div class="small-4 columns">
        <span v-dompurify-html="$t('EVENTS.SIDEBAR_TXT')" />
      </div>
    </div>
    <!-- Add Event -->
    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <new-event :on-close="hideAddPopup" />
    </woot-modal>
    <!-- Edit Event -->
    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-event
        v-if="showEditPopup"
        :id="selectedEvent.id"
        :value="selectedEvent"
        :on-close="hideEditPopup"
      />
    </woot-modal>
    <!-- Delete Event -->
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('EVENTS.DELETE.TITLE')"
      :message="$t('EVENTS.DELETE.CONFIRMATION')"
      :message-value="deleteMessage"
      :confirm-text="$t('EVENTS.DELETE.CONFIRM_YES')"
      :reject-text="$t('EVENTS.DELETE.CONFIRM_NO')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import NewEvent from './NewEvent';
import EditEvent from './EditEvent';
import EventTableRow from './EventRow';

export default {
  components: {
    NewEvent,
    EditEvent,
    EventTableRow,
  },
  mixins: [alertMixin],
  data() {
    return {
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedEvent: {},
      loading: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'events/getEvents',
      uiFlags: 'events/getUIFlags',
    }),
    deleteMessage() {
      return ` ${this.selectedEvent.event_name}?`;
    },
  },
  mounted() {
    this.$store.dispatch('events/get', { include_inactive: true });
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    openDeletePopup(event) {
      this.showDeleteConfirmationPopup = true;
      this.selectedEvent = event;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    openEditPopup(event) {
      this.showEditPopup = true;
      this.selectedEvent = event;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    confirmDeletion() {
      this.loading[this.selectedEvent.id] = true;
      this.deleteEvent(this.selectedEvent.id);
      this.closeDeletePopup();
    },
    async deleteEvent(id) {
      try {
        await this.$store.dispatch('events/delete', id);
        this.showAlert(this.$t('EVENTS.DELETE.API.SUCCESS_MESSAGE'));
        this.loading[this.selectedEvent.id] = false;
      } catch (error) {
        this.showAlert(this.$t('EVENTS.DELETE.API.ERROR_MESSAGE'));
      }
    },
    async toggleEventActive(event) {
      try {
        await this.$store.dispatch('events/toggleActive', event.id);
        this.showAlert(this.$t('EVENTS.TOGGLE_ACTIVE.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('EVENTS.TOGGLE_ACTIVE.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.events__empty-state {
  padding: var(--space-large);
  text-align: center;
}
</style>
